import { ENGLISH, SPANISH } from "../context/languaje/types";

export const LEAGUES = {
  Unranked: "Unranked",
  Iron: "Iron",
  Bronze: "Bronze",
  Silver: "Silver",
  Gold: "Gold",
  Platinum: "Platinum",
  Diamond: "Diamond",
  Master: "Master",
  GrandMaster: "GrandMaster",
  Challenger: "Challenger",
};

export const ROUTES = {
  BOOSTING: "/boosting",
  DIVISIONBOOST: "/boosting/divisionboost",
  PLACEMENTS: "/boosting/placements",
  NETWINS: "/boosting/netwins",
  COACHING: "/coaching",
  ABOUTUS: "/aboutus",
  RECENTWORKS: "/works",
  FREQUENTQUESTIONS: "/frequentquestions",
};

export const TITLES = {
  BOOSTING: "Boosting",
  DIVISIONBOOST: "Division Boost",
  PLACEMENTS: "Placements",
  NETWINS: "Net Wins",
  COACHING: "Coaching",
};

export const CLASSNAMES = {
  BOOSTING: "boosting",
  BOOSTING_TEXT: "boosting-text",
  COACHING_TEXT: "coaching-text",
  COACHING: "coaching",
};

export const COLORS = {
  PURPLE: "purple",
  BLUE: "blue",
  GREEN: "green",
  RED: "red",
  GOLD: "gold",
  ORANGE: "orange",
};

export const LEAGUE_OF_LEGENDS = "League of Legends";

export const FORM_TYPES = {
  SELECT: "select",
  MULTIPLE: "multiple",
  TOGGLE: "toggle",
  DIVISIONAL: "divisional",
  RANGE: "range",
  NUMBER: "number",
};

export const ANYFILL = "Any";

export const FILLED = "filled";

export const FORM_PREFERENCES_NAMES_EN = {
  SERVER: "Server",
  QUEUE: "Queue",
  ROL: "Rol",
  SUMMONERS: "Summoners",
  MAIN: "Main",
  SECONDARY: "Secondary",
  PREFERENCES: "Preferences",
  CHAMPIONS_POOL: "Champions pool",
  DUO_QUEUE: "Duo Queue",
  ORDER_PREMIUM: "Order Premium",
  BOOSTING_RANK_NAME: "boostingRank",
  DESIRED_RANK_NAME: "desiredRank",
  PLACEMENTS_RANK_NAME: "placementsRank",
  NETWINS_RANK_NAME: "netWinsRank",
  NRO_PLACEMENTS_RANK_NAME: "nroPlacements",
  NRO_NETWINS_RANK_NAME: "nroNetWins",
  CURRENT_RANK: "Current Rank",
  DESIRED_RANK: "Desired Rank",
  PREVIOUS_RANK: "Previous Rank",
  NUMBER_OF_GAMES: "Number of games",
  NUMBER_OF_WINS: "Number of wins",
  CHAMPIONS: "Champions",
  FROM: "FROM",
  TO: "TO",
  VICTORIES: "Victories",
  PLACEMENT_GAMES: "Placement games",
};

export const FORM_PREFERENCES_NAMES_ES = {
  SERVER: "Servidor",
  QUEUE: "Cola",
  ROL: "Roles",
  SUMMONERS: "Hechizos",
  MAIN: "Principal",
  SECONDARY: "Secundario",
  PREFERENCES: "Preferencias",
  CHAMPIONS_POOL: "Pool de campeones",
  DUO_QUEUE: "Duo Queue",
  ORDER_PREMIUM: "Orden Premium",
  BOOSTING_RANK_NAME: "boostingRank",
  DESIRED_RANK_NAME: "desiredRank",
  PLACEMENTS_RANK_NAME: "placementsRank",
  NETWINS_RANK_NAME: "netWinsRank",
  NRO_PLACEMENTS_RANK_NAME: "nroPlacements",
  NRO_NETWINS_RANK_NAME: "nroNetWins",
  CURRENT_RANK: "Rango Actual",
  DESIRED_RANK: "Rango Deseado",
  PREVIOUS_RANK: "Rango Anterior",
  NUMBER_OF_GAMES: "Número de juegos",
  NUMBER_OF_WINS: "Número de victorias",
  CHAMPIONS: "Campeones",
  FROM: "Desde",
  TO: "Hasta",
  VICTORIES: "Victorias",
  PLACEMENT_GAMES: "Juegos de posicionamiento",
};

export const PREFERENCES_PROPERTIES = {
  LEAGUE: "league",
  NRO_GAMES: "nroGames",
  UNRANKED: "Unranked",
  DIVISION: "division",
  LP_GROUP: "lpGroup",
  LPS: "lps",
  LP_GAIN: "lpGain",
};

export const QUEUES = {
  SOLO: "Solo Queue",
  FLEX: "Flex Queue",
};

export const SEE_PLANS = {
  [SPANISH]: "Ver Planes",
  [ENGLISH]: "See Plans",
};

export const FOOTER_LABEL = {
  [SPANISH]: "Todos los derechos reservados 2023",
  [ENGLISH]: "All rights reserved 2023",
};

export const RECENT_WORKS = {
  [SPANISH]: "Trabajos recientes",
  [ENGLISH]: "Recent works",
};

export const FREQUENT_QUESTIONS = {
  [SPANISH]: "Preguntas frecuentes",
  [ENGLISH]: "Frequent questions",
};

export const ABOUT_US = {
  [SPANISH]: "Sobre nosotros",
  [ENGLISH]: "About us",
};

export const HOME_TITLE = {
  [SPANISH]: "¿CUAL ES TU SERVICIO REQUERIDO?",
  [ENGLISH]: "WHAT IS YOUR REQUIRED SERVICE?",
};

export const YOUR_ORDER = {
  [SPANISH]: "Su pedido",
  [ENGLISH]: "Your order",
};

export const PAY_LABEL = {
  [SPANISH]: "Pagar",
  [ENGLISH]: "Pay",
};

export const ORDER_LABEL = {
  [SPANISH]: "Ordenar",
  [ENGLISH]: "Order now",
};

export const QUOTE_LABEL = {
  [SPANISH]: "Cotizar",
  [ENGLISH]: "Quote now",
};

export const IS_FREE = {
  [SPANISH]: "Gratis",
  [ENGLISH]: "Free",
};

export const USD = "USD";
export const COP = "COP";

export const highElo = [
  LEAGUES.Master,
  LEAGUES.GrandMaster,
  LEAGUES.Challenger,
];

export const SERVERS = {
  LAN: "LAN",
  LAS: "LAS",
  NA: "NA",
  BR: "BR",
};

export const latamServers = [SERVERS.LAN, SERVERS.LAS];

export const LEAGUE_COLORS = {
  Unranked: "#6b6b6b",
  Iron: "#4a3d38",
  Bronze: "#563833",
  Silver: "#516c7e",
  Gold: "#734c20",
  Platinum: "#019a91",
  Diamond: "#4464b4",
  Master: "#9a3dac",
  GrandMaster: "#652324",
  Challenger: "#02224f",
};

export const coachTypes = {
  SINGLE_CAPITALIZED: "Single",
  SINGLE: "single",
  INDIVIDUAL_CAPITALIZED: "Inividual",
  INDIVIDUAL: "inividual",
  TEAM: "team",
};
